import { ComboBox, InputMaskField, TextInput, Button } from '@components';
import { marital } from '@utils';
import { Field, useFormikContext } from 'formik';
import React, { useEffect } from 'react';

export const DadosContatoForm = ({
  isEdit,
  setIsEdit,
  isActive,
  bloqueioEmail,
}) => {
  const { setFieldValue, resetForm, values, setTouched } = useFormikContext();
  useEffect(() => {
    if (isEdit && isActive) {
      setTouched({ celular: true, email: true, telefoneFixo: true }, true);
    }
  }, [isActive, isEdit, setTouched]);

  return (
    <>
      <div className="col-md-12">
        {isEdit && (
          <div className="d-flex justify-content-between mt-4 mb-4">
            <h3 className="mb-32 ts-16 fw-bold">
              Editando: Dados de Contato
              <div className="row">
                <p className="text-orange ts-16 mt-2">
                  Atenção: para salvar suas alterações, você precisa avançar até
                  a última etapa do formulário.
                </p>
              </div>
            </h3>
            <div className="col-md-2 d-flex justify-content-end">
              <Button
                type="button"
                color="orange"
                transparent
                onClick={() => {
                  setIsEdit(false);
                  resetForm();
                }}
                className="d-flex justify-content-center"
              >
                Cancelar edição
              </Button>
            </div>
          </div>
        )}
      </div>

      <div className="row">
        <div className="col-12 col-md-6">
          <Field
            name="email"
            disabled={!isEdit || bloqueioEmail}
            className="mb-3"
            component={TextInput}
            label="E-mail principal"
          />
        </div>
        <div className="col-12 col-md-6">
          <Field
            name="celular"
            disabled={!isEdit}
            className="mb-3"
            mask="(11) 11111-1111"
            inputMode="numeric"
            component={InputMaskField}
            label="Celular"
            onChange={(e) => {
              setFieldValue('celular', e.target.value);
            }}
          />
        </div>

        <div className="col-12 col-md-6">
          <Field
            name="telefoneFixo"
            disabled={!isEdit}
            className="mb-3"
            mask="(11) 1111-1111"
            inputMode="numeric"
            component={InputMaskField}
            label="Telefone fixo"
            onChange={(e) => {
              setFieldValue('telefoneFixo', e.target.value);
            }}
          />
        </div>
      </div>

      {(values.estadoCivil === '' || values.estadoCivil === 'Outros') && (
        <>
          <hr />
          <div className="row mt-32 mb-32">
            <p className="ts-16">
              Verificamos que você não possui estado civil informado. Pedimos
              que preencha também o campo abaixo, por favor:
            </p>
            <Field
              name="estadoCivil"
              className="mb-3 mt-3 col-12 col-md-4"
              disabled={!isEdit}
              component={ComboBox}
              label="Estado Civil"
              options={marital.map((s) => {
                return { value: s, label: s };
              })}
            />
          </div>
        </>
      )}
    </>
  );
};
